import { isNumber } from "lodash";
import moment from "moment";

import { LOCAL_DATE_TIME_FORMAT, TIMESTAMP } from "./constants";

export const formatTimestamp = ({
  ts,
  units = TIMESTAMP.UNITS.MILLISECONDS,
  timezone = TIMESTAMP.ZONE.UTC,
  format = LOCAL_DATE_TIME_FORMAT,
}) => {
  if (!isNumber(ts)) {
    throw new Error(`Invalid timestamp: ${ts}, should be a number`);
  }
  if (
    units !== TIMESTAMP.UNITS.SECONDS &&
    units !== TIMESTAMP.UNITS.MILLISECONDS
  ) {
    throw new Error(
      `Invalid timestamp units: ${units}, should be either '${TIMESTAMP.UNITS.SECONDS}' or '${TIMESTAMP.UNITS.MILLISECONDS}'`
    );
  }
  if (timezone !== TIMESTAMP.ZONE.LOCAL && timezone !== TIMESTAMP.ZONE.UTC) {
    throw new Error(
      `Invalid timezone: ${timezone}, should be either '${TIMESTAMP.ZONE.LOCAL}' or '${TIMESTAMP.ZONE.UTC}'`
    );
  }

  // Notes:
  // - The `moment()` call expects milliseconds, and `moment.unit()` expects seconds.
  // - The `local()` call appears redundant, but it makes things clear.
  // See https://momentjs.com/docs/#/parsing/unix-timestamp/
  let dateObj =
    units === TIMESTAMP.UNITS.SECONDS ? moment.unix(ts) : moment(ts);
  dateObj = timezone === TIMESTAMP.ZONE.LOCAL ? dateObj.local() : dateObj.utc();
  return dateObj.format(format);
};

export const timestampFormatter = (units, timezone, format) => (ts) =>
  formatTimestamp({ ts, units, timezone, format });
